// src/pages/History/RenaissanceReformation/ScientificRevolution.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Renaissance_&_Reformation_-_Scientific_Revolution.png';

export default function HistoryPageScientificRevolution() {
  return (
    <TopicPage
      topicKey="Scientific Revolution"
      title="History: Scientific Revolution"
      backgroundImage={bg}
      startRoute="/History-Scientific-Revolution-Go"
      scrollLabels={[
        "Copernican Heliocentrism",
        "Galileo and Newton",
        "Scientific Method and Discovery",
      ]}
      backRoute="/history-renaissance"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
